<template>
  <div>
    <div style="text-align:center;color:lightgray;padding-top:20px;padding-bottom:0px">
      <h6>Munde Bwino Quote</h6>
    </div>
    <div>
      <v-stepper
        v-model="e1" 
        style="background-color:transparent;padding-top:0px;padding-bottom:0px" 
        dark  
      >
        <v-stepper-header style="font-size:12px;padding-bottom:0px;padding-top:0px;color:lightgray">
          <v-stepper-step :complete="e1 > 1" step="1">Client Details</v-stepper-step>
          <v-divider></v-divider>          
          <v-stepper-step :complete="e1 > 2" step="2">Travel Details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Quotation Details</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content dark step="1" style="height:380px">
            <div style="height:280px">
                <v-form ref="form1">
                  <v-row class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >                   
                      <v-text-field v-if="user.loggedIn"
                        placeholder="First name *"                        
                        v-model="user.data.first_name"                    
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense            
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-right:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                      <v-text-field v-else
                        placeholder="First name *"                        
                        v-model="custom.first_name"                    
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense            
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-right:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col>
                    <v-col 
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    > 
                      <v-text-field v-if="user.loggedIn"
                        placeholder="Last name *"
                        v-model="user.data.last_name"                      
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense                       
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                      <v-text-field v-else
                        placeholder="Last name *"
                        v-model="custom.last_name"                      
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense                       
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >    
                      <vue-phone-number-input
                        v-model="custom.phone_number" 
                        placeholder="Phone number"
                        default-country-code="ZM"
                        required
                        dark
                        @update="getPhoneNumber"
                        no-example
                        style="padding-right:5px"
                      />
                    </v-col>
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >   
                      <v-text-field v-if="user.loggedIn"
                        placeholder="National ID *"
                        v-model="user.data.national_id"                      
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense                       
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                      <v-text-field v-else
                        placeholder="National ID *"
                        v-model="traveller.nrc"                      
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense                       
                        outlined
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >       
                      <v-menu
                        :v-model="menu2"
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="computedDateFormatted"
                            placeholder="Start date *"
                            readonly
                            required
                            outlined
                            background-color="rgb(66,66,66,0.85)"
                            @change="quote=true"
                            dense
                            :rules="[v => !!v || 'Required field']"
                            v-on="on"
                            style="padding-right:5px;color:lightgray;font-size:12px"
                          ></v-text-field>
                        </template>
                        <v-date-picker 
                          v-model="date" 
                          no-title 
                          @input="menu2 = false"
                          :allowed-dates="allowedDates"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col 
                      class="ma-0 pa-0"
                      cols="12"
                      sm="3"
                    > 
                      <v-text-field
                        placeholder="Total months *"                        
                        v-model="muendeBwino.num_of_months"                    
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense            
                        outlined
                        type="number"
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col> 
                    <v-col 
                      class="ma-0 pa-0"
                      cols="12"
                      sm="3"
                    > 
                      <v-text-field
                        placeholder="Total travellers *"                        
                        v-model="muendeBwino.num_of_travellers"                    
                        required
                        :rules="[v => !!v || 'Required field']"
                        dense            
                        outlined
                        type="number"
                        background-color="rgb(66,66,66,0.85)"          
                        style="padding-left:5px;color:lightgray;font-size:12px"
                      >  
                      </v-text-field>
                    </v-col>   
                  </v-row>    
                </v-form>
              </div>
              <v-divider></v-divider> 
            <v-btn
              text
              outlined
              @click="validate(1)"
            >
              Continue
            </v-btn>
            <v-btn 
              outlined
              text
              @click="closeProduct"
              style="margin-left:5px"
            >
              Cancel
            </v-btn>
          </v-stepper-content>
          <v-stepper-content step="2" style="height:380px">
            <div style="height:280px">
                <v-form class="ma-0 pa-0" ref="form2"> 
                  <v-expansion-panels
                    v-model="panel"
                    accordion
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header>Add Traveller</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row 
                            class="ma-0 pa-0"
                          >
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >                 
                              <v-text-field
                                placeholder="First name"                         
                                v-model="traveller.first_name"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >                 
                              <v-text-field
                                placeholder="Last name"                         
                                v-model="traveller.last_name"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >  
                              <v-text-field
                                placeholder="National ID"                         
                                v-model="traveller.nrc"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >       
                              <v-text-field
                                placeholder="Phone number"                         
                                v-model="traveller.phone_number"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>       
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>Add Beneficiary</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row 
                            class="ma-0 pa-0"
                          >
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >                 
                              <v-text-field
                                placeholder="First name"                         
                                v-model="beneficiary.first_name"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >  
                              <v-text-field
                                placeholder="Last name"                         
                                v-model="beneficiary.last_name"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >       
                              <v-text-field
                                placeholder="Phone number"                         
                                v-model="beneficiary.phone_number"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col> 
                            <v-col
                              cols="12"
                              sm="3"
                              class="ma-0 pa-0"
                            >             
                              <v-text-field
                                placeholder="National ID"                         
                                v-model="beneficiary.identification"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>       
                          </v-row>
                          <v-row 
                            class="ma-0 pa-0"
                          >
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >                 
                              <v-text-field
                                placeholder="Residential address"                         
                                v-model="beneficiary.residential_address"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >  
                              <v-text-field
                                placeholder="Email address"                         
                                v-model="beneficiary.email"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col>
                            <v-col
                              class="ma-0 pa-0"
                              cols="12"
                              sm="3"
                            >       
                              <v-text-field
                                placeholder="Relationship"                         
                                v-model="beneficiary.relationship"
                                dense            
                                outlined
                                background-color="rgb(66,66,66,0.85)"          
                                style="padding-left:5px;color:lightgray;font-size:12px" 
                                :rules="[v => !!v || '*Required']"
                              >  
                              </v-text-field>
                            </v-col> 
                            <v-col
                              cols="12"
                              sm="3"
                              class="ma-0 pa-0"
                            >             
                              <v-btn
                                text
                                outlined
                                @click="addItem()"
                                style="margin-left:5px;color:lightgray;border:1px solid lightgray;font-size:10px"
                              >
                                Add to List
                              </v-btn>
                            </v-col>       
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>Traveller List</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-simple-table dense style="background-color:transparent" height="130px">
                          <thead>
                            <tr v-if="muendeBwino.travellers.length > 0">
                              <th class="text-left">Name</th>
                              <th class="text-left">National ID</th>
                              <th class="text-left">Mobile #</th>
                              <th class="text-left">Beneficiary</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr 
                              v-for="(nomad,index) in muendeBwino.travellers"
                              :key="index"
                            >
                              <td style="font-size:10px">{{ nomad.first_name }} {{ nomad.last_name }}</td>
                              <td style="font-size:10px">{{ nomad.nrc }}</td>
                              <td style="font-size:10px">{{ nomad.phone_number }}</td>
                              <td style="font-size:10px">{{ nomad.beneficiary[0].first_name }} {{ nomad.beneficiary[0].last_name }}}</td>
                              <td width="10%"><v-btn title="Delete item" small icon @click="deleteItem(index)"><v-icon>mdi-delete</v-icon></v-btn></td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-form>
              </div>
              <v-divider></v-divider>
            <v-btn
              text
              outlined
              @click="e1 = 3;getPremium()"
            >
              Continue
            </v-btn>
            <v-btn 
              text
              outlined
              style="margin-left:5px"
              @click="e1 = 1"
            >
              Previous
            </v-btn>
          </v-stepper-content>
          <v-stepper-content dark step="3" style="height:380px">
            <div style="height:280px;font-size:12px">
              <v-form ref="form"> 
                <div style="color:white" class="pa-0 ma-0">Client Details</div> 
                  <v-row
                    class="ma-0 pa-0"
                  >
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                    >
                      <v-simple-table dense style="background-color:transparent" height="50px">
                        <thead>
                          <tr>
                            <th width="60%" v-if="user.loggedIn" class="text-left"> {{ user.data.first_name }} {{ user.data.last_name }} </th>
                            <th width="60%" v-else class="text-left"> {{ custom.first_name }} {{ custom.last_name }} </th>
                            <th v-if="user.loggedIn" class="text-left"> {{ user.data.phone_number }} </th>
                            <th v-else class="text-left"> {{ custom.phone_number }} </th>
                          </tr>
                        </thead>
                      </v-simple-table> 
                    </v-col>
                    <v-col
                      class="ma-0 pa-0"
                      cols="12"
                      sm="6"
                      style="text-align:right"
                    >
                      <v-btn 
                        text
                        @click="downloadQuotation"
                        outlined
                        style="margin-right:5px;color:lightgray;border:1px solid lightgray"              
                      >
                        Download Quotation
                      </v-btn>
                    </v-col> 
                  </v-row>            
                  <div class="pa-0 ma-0" style="color:white">Traveller Details</div> 
                    <v-simple-table dense style="background-color:transparent" height="120px">
                      <thead>
                        <tr v-if="muendeBwino.travellers.length > 0">
                          <th class="text-left">Name</th>
                          <th class="text-left">National ID</th>
                          <th class="text-left">Mobile #</th>
                          <th class="text-left">Beneficiary</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr 
                          v-for="(nomad,index) in muendeBwino.travellers"
                          :key="index"
                        >
                          <td style="font-size:10px">{{ nomad.first_name }} {{ nomad.last_name }}</td>
                          <td style="font-size:10px">{{ nomad.nrc }}</td>
                          <td style="font-size:10px">{{ nomad.phone_number }}</td>
                          <td style="font-size:10px">{{ nomad.beneficiary[0].first_name }} {{ nomad.beneficiary[0].last_name }}}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>      
                    <div style="color:white">Muende Bwino Quotation Details</div>     
                      <v-simple-table dense style="background-color:transparent" height="60px">
                      <thead>
                        <tr>
                          <th class="text-left">Start Date</th>
                          <th class="text-left">End Date</th>
                          <th class="text-left">Month(s)</th>
                          <th class="text-left">Traveller(s)</th>
                          <th class="text-left" style="color:orange">Premium</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="font-size:10px">{{ muendeBwino.start_date }}</td>
                          <td style="font-size:10px">{{ muendeBwino.end_date }}</td>
                          <td style="font-size:10px">{{ muendeBwino.num_of_months }}</td>
                          <td style="font-size:10px">{{ muendeBwino.num_of_travellers }}</td>
                          <td style="font-size:12px"><b>K {{ muendeBwino.premium }}</b></td>
                        </tr>
                      </tbody>
                    </v-simple-table>  
                    <v-row
                      class="ma-0 pa-0"
                    >
                      <v-col
                        class="pa-0 ma-0"
                        cols="12"
                        sm="1"
                      >
                        <v-checkbox 
                          style="padding:0px;margin:0px"
                          class="mx-2"
                          color="blue"
                          v-model="accepted"  
                        >
                        </v-checkbox> 
                      </v-col>
                      <v-col
                        class="pa-0 ma-0"
                        cols="12"
                        sm="11"
                      >
                        <p style="color:white;font-size:12px;padding-top:5px">I Accept the <a style="color:yellowgreen" href="/terms" target="_blank">PICZ Terms of Use</a></p>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
            <v-divider></v-divider>                 
              <CheckoutModal v-if="user.loggedIn"
                :isProduction="isProduction"
                :email="user.data.email_address"
                :amount="parseFloat(muendeBwino.total_value)"
                :reference="reference"
                :rave-key="raveKey"
                :callback="callback"
                :close="close"
                :currency="currency"
                :country="country"         
                :payment_method="paymentMethod"
                :accepted="accepted"
              />
              <CheckoutModal v-else
                color="primary"
                :isProduction="isProduction"
                :email="custom.email_address"
                :amount="parseFloat(muendeBwino.total_value)"
                :reference="reference"
                :rave-key="raveKey"
                :callback="callback"
                :close="close"
                :currency="currency"
                :country="country"
                :payment_method="paymentMethod"
                :accepted="accepted"
              />
            
            <v-btn 
              text
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray"
              @click="e1 = 2"
            >
              Previous
            </v-btn>
            <v-btn
              text
              @click="openBottomSheet(6)"
              outlined
              style="margin-left:5px;color:lightgray;border:1px solid lightgray" 
            >
              View Benefits
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
     </v-stepper>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import { mapGetters } from "vuex";
  import CheckoutModal from "@/components/modals/CheckoutModal.vue";
  import moment from 'moment';
  import jsPDF from 'jspdf';

  const raveKey = process.env.VUE_APP_RAVE_TEST_KEY;
  const CREATE_MB_QUOTE_URL = "http://139.59.131.242:4000/mb/createQuotation";
  const AUTHORIZE_MB_QUOTE_URL = "http://139.59.131.242:4000/mb/authorize/";
  const GET_POLICIES_URL = "http://139.59.131.242:4000/client/allClientPolicies";

  export default {
    name: 'MuendeBwinoQuote',
    components: {
      CheckoutModal
    },
    data: () => ({
      e1: 1,
      steps: 3,
      travel_list: [
        { text: 'Local', value: 'lcl' }
      ],
      plan_list: [
        { text: 'Incl. US & Canada', value: '1'},
        { text: 'Excl. US & Canada', value: '2'}
      ],
      input_rules: [
       // v => v.length > 0 || 'This field is required'
      ],
      age_range: [
        { text: '0 - 40 yrs', value: '0' },
        { text: '41 - 60 yrs', value: '2' },
        { text: '61 - 70 yrs', value: '3' }
      ],
      custom: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
        province: {
          text: '',
          value: ''
        },
        city: {
          text: '',
          value: ''
        },
        physical_address: '',
        delivery_date: '',
        delivery_time: '',
        coordinates: {
          latitude: '',
          longitude: ''
        },
      },
      panel: 0,
      dialog: false,
      isProduction: false,
      raveKey: raveKey,
      amount: "",
      currency: "ZMW",
      country: "ZM",
      paymentMethod: "",
      delivery: false,
      isPrimary: true,
      province_list: [
        { text: 'Lusaka', value: 'lsk' },
        { text: 'Copperbelt', value: 'cbt' }
      ],
      city_list: [
        { text: 'Lusaka', value: 'lsk' },
        { text: 'Ndola' , value: 'ndl' },
        { text: 'Kitwe', value: 'ktk' },
        { text: 'Chingola', value: 'cng' },
        { text: 'Luanshya', value: 'lya' },
        { text: 'Kalulushi', value: 'kls' },
        { text: 'Mufurila', value: 'muf' },
      ],
      traveller:{
        first_name: '',
        last_name: '',
        name: '',
        nrc: '',
        phone_number: '',
        beneficiary:[]
      },
      beneficiary :{
        first_name : '',
        last_name : '',
        phone_number : '',
        residential_address : '',
        identification : '',
        email : '',
        relationship : ''
      },       
      loading: false,
      menu2: false,
      showBeneficiary: false,
      date: new Date().toISOString().substr(0, 10),
      quotation: null,
      accepted: false
    }),
    watch: {
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
      vertical () {
        this.e1 = 2
        requestAnimationFrame(() => this.e1 = 1) // Workarounds
      }
    },
    methods: {
      allowedDates: val => moment(val).isSameOrAfter(new Date(), 'day'),
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      downloadQuotation() {   
        var first_name = '';
        var last_name = '';

        if (this.user.loggedIn){
          first_name = this.user.data.first_name;
          last_name = this.user.data.last_name;
        }else{
          first_name = this.custom.first_name;
          last_name = this.custom.last_name;
        }

        var doc = new jsPDF();

        var imgData = "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";
        
        doc.addImage(imgData, 'JPEG', 15, 10, 60, 26);

        var x=15;
        var y=40;

        doc.setFillColor(176,223,229);
        doc.rect(x, y, 180, 40, 'DF');

        doc.addFont('Book Antiqua');
        doc.setFont('Book Antiqua');
        doc.setFontSize(12);
        
        x = x + 2;
        y = y + 5;
        doc.text("We  are  pleased to render our  terms  and  conditions  for  your favourable consideration  as contained", x, y,);
        y = y + 5;
        doc.text("herein.", x, y,);
        y = y + 8;
        doc.text("Also note that PICZ is currently the only primary insurance company in Zambia with a credit rating. We ", x, y,);
        y = y + 5;
        doc.text("are rated A+ by Global Credit Rating-(GCR). Details on the  same can be  availed to you on request but ", x, y,);
        y = y + 5;
        doc.text("suffice to say that the rating evidences our ability to pay claims timely. ", x, y,);

        x = x - 1;
        y = y + 30;
        doc.setTextColor(212,175,55);

        doc.text(first_name + " " + last_name, x, y,)

        doc.setTextColor(0,0,0);
        doc.setFontStyle('bold');

        y = y + 8;
        doc.text("Quotation", x, y,);

        //var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

        y = y + 8;
        doc.text("Period of Cover", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      " + this.muendeBwino.start_date + " to " + this.muendeBwino.end_date, x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Insurer", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      Professional Insurance Corporation Zambia Plc", x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Branch/Unit", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      Digital Channels", x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Quotation prepared on", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      " + this.formatDate(new Date().toISOString().substr(0, 10)), x+50, y,);
        doc.setFontStyle('bold');
        y = y + 8;
        doc.text("Validity of Quotation", x, y,);
        doc.setFontStyle('normal');
        doc.text(":      30 days", x+50, y,);

        y = y + 20;
        doc.text("We hope that you will find our quotation favourable and look forward to your instructions to place cover.", x, y,);
        
        y = y + 10;

        doc.setFillColor(176,223,229);
        doc.rect(x+55, y, 70, 5, 'DF');

        y = y + 4;
        doc.setTextColor(0,0,128);
        doc.text("MUENDE BWINO POLICY", x+56, y,);

        y = y + 10;
        doc.text("COVER", x, y,);
        y = y + 8;
        doc.setTextColor(0,0,0);
        doc.text("Personal accident plan for commuters on a monthly basis for their insurance cover.", x,y,);
        y = y + 5;
        doc.text("This cover provides for cash compensation in the event of death or injury sustained ",x,y,);
        y = y + 5;
        doc.text("as a result of a road traffic accident and medical expenses cover for costs that ",x,y,);
        y = y + 5;
        doc.text("may be incurred.",x,y,);

        y = y + 12;
        
        doc.setTextColor(0,0,128);
        doc.text("INTEREST", x, y,);

        y = y + 5;
        doc.setFillColor(211,211,211);
        doc.rect(x, y, 180, 14, 'DF');
        doc.setTextColor(0,0,0);
        doc.text("Interest", x+1,y+4,);
        doc.text("Months", x+37,y+4,);
        doc.text("Benefit Level Per Person", x+63,y+4,);
        doc.text("Rate Per Person", x+109,y+4,);
        doc.text("Premium", x+145,y+4,);

        y = y + 7;
        doc.text("Per Month (ZMW)", x+63,y+4,);
        doc.text("Per Month (ZMW)", x+109,y+4,);
        doc.text("Per Month (ZMW)", x+145,y+4,);

        y = y + 7;
        var monthlyPremium = parseFloat(this.muendeBwino.num_of_travellers) * 5;

        doc.rect(x, y, 180, 7);
        doc.line(x+36, y-14, x+36, y+7);
        doc.line(x+62, y-14, x+62, y+7);
        doc.line(x+108, y-14, x+108, y+7);
        doc.line(x+144, y-14, x+144, y+14);
        doc.text(this.muendeBwino.num_of_travellers + " Traveller(s)", x+1,y+4,);
        doc.text(this.muendeBwino.num_of_months + " Month(s)", x+37,y+4,);
        doc.text("5,000.00", x+63,y+4,);
        doc.text("5.00", x+109,y+4,);
        doc.text(monthlyPremium.toFixed(2), x+145,y+4,);

        y = y + 7;
        var totalPremium = parseFloat(this.muendeBwino.num_of_months) * monthlyPremium;

        doc.rect(x, y, 180, 7);
        doc.line(x+144, y-7, x+144, y+7);
        doc.text("Total Premium inclusive Levy @ 3%", x+1,y+4,);
        doc.text(totalPremium.toFixed(2), x+145,y+4,);
        
        doc.addPage();
        y = 30;
        
        doc.text("BENEFITS", x, y,);
        y = y + 8;
        doc.setFontStyle('italics');
        doc.text("1.	Benefit level – K5,000.00 for Injury or death per event/aggregate",x+10,y,);
        y = y + 5;
        doc.text("2.	Benefit Level – of up to K1,000.00 for emergency medical, First Aid and ambulance ", x+10, y,);
        y = y + 5;
        doc.text("    fees following a road traffic accident",x+10,y,);
        y = y + 5;
        doc.text("3.	The cover will continue for the reminder of the duration of the policy. ", x+10, y,);

        
        y = y + 8;
        doc.setFontStyle('normal');
        doc.text("EXCESS", x, y,);
        y = y + 8;
        doc.text("Nill", x, y,);
        
        y = y + 8;
        doc.text("Requirements for issuance of cover:", x, y,);
        y = y + 8;
        doc.setFontStyle('italics');
        doc.text("1. NRC number",x+10,y,);
        y = y + 5;
        doc.text("2. Mobile contact number", x+10, y,);
        y = y + 5;
        doc.text("3. Beneficiary contact number", x+10, y,);
        doc.setFontStyle('normal');
        doc.setTextColor(255,0,0);
        y = y + 8;
        doc.text("QUOTATION SUBJECT TO PICZ STANDARD WORDING, TERMS & CONDITIONS ", x, y,);        
        
        doc.save('Quotation.pdf'); 
        doc.output('dataurlnewwindow');
      },
      addItem(){        
        if (this.$refs.form2.validate()){     
          if (this.muendeBwino.num_of_travellers > this.muendeBwino.travellers.length){  
            var total_value = parseFloat(this.muendeBwino.total_value);
            var num_of_months = parseInt(this.muendeBwino.num_of_months);
            
            total_value = total_value + 5 * num_of_months;
            
            this.muendeBwino.total_value = total_value.toFixed(2);

            this.traveller.name = this.traveller.first_name + ' ' + this.traveller.last_name;
            this.traveller.beneficiary.push(this.beneficiary);
            this.muendeBwino.travellers.push(this.traveller);

            this.traveller = {
              first_name: '',
              last_name: '',
              name: '',
              nrc: '',
              phone_number: '',
              beneficiary:[]
            };

            this.beneficiary = {
              first_name : '',
              last_name : '',
              phone_number : '',
              residential_address : '',
              identification : '',
              email : '',
              relationship : ''
            },       

            this.showBeneficiary = false;
            this.panel = 2;
          }
        }else{
          this.showAlert('You have exceeded the number of travellers specified!','danger');
        }
      },
      deleteItem(index){                    
        var total_value = parseFloat(this.muendeBwino.total_value);
        var num_of_months = parseInt(this.muendeBwino.num_of_months);
        
        total_value = total_value - num_of_months * 5;
        
        this.muendeBwino.total_value = total_value.toFixed(2);
        
        this.muendeBwino.travellers.splice(index,1);
        
      },
      validate(step){
        if (step == "1"){
          if (this.$refs.form1.validate()){
            this.e1 = parseInt(step) + 1;
            if (this.muendeBwino.travellers.length == 0){
              if (this.user.loggedIn){
                this.traveller.first_name = this.user.data.first_name;
                this.traveller.last_name = this.user.data.last_name;
                //this.traveller.name = this.user.data.first_name + " " + this.user.data.last_name;
                this.traveller.nrc = this.user.data.national_id;
                this.traveller.phone_number = this.user.data.phone_number;
              }else{
                this.traveller.first_name = this.custom.first_name;
                this.traveller.last_name = this.custom.last_name;
                //this.traveller.name = this.custom.first_name + " " + this.custom.last_name;
                this.traveller.nrc = this.user.data.national_id;
                //this.traveller.phone_number = this.getPhoneNumber();
              }
            }
          }
        }
        if (step == "2"){
          if (this.$refs.form2.validate()){
            //this.e1 = parseInt(step) + 1;
          }
        }
      },
      getPhoneNumber(payload){
        this.user.data.phone_number = payload.formattedNumber;
      },
      submit() {
        if (this.$refs.form.validate()){
          this.loading = true;
        }
      },
      onInput (val) {
        this.steps = parseInt(val)
      },
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      closeProduct(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=true;
        this.components.nav_drawer.expand_on_hover=true;
      },
      getPremium(){ 
        if (this.muendeBwino.num_of_travellers == this.muendeBwino.travellers.length){
          this.muendeBwino.start_date = this.formatDate(this.date);

          var data = {
            digital_channel: "2",
            client_id: this.user.data.client_id,
            client_type: "individual_client",
            start_date: this.muendeBwino.start_date,
            currency: "ZMW",
            num_of_travellers: this.muendeBwino.num_of_travellers,
            num_of_months: this.muendeBwino.num_of_months,
            created_by: this.user.data.user_id,
            agency_id: 44,
            travellers: this.muendeBwino.travellers
          }; 
          
          axios
          .post(CREATE_MB_QUOTE_URL,data)
          .then(response => {
            if (response.data.status == "Transaction was successfully created"){
              this.quotation = response.data.quoatation;
              this.muendeBwino.end_date = this.formatDate(this.quotation.end_date.substr(0, 10));
              this.muendeBwino.quote_id = this.quotation.id;
              this.muendeBwino.quote_number = this.quotation.transaction_number;
              this.muendeBwino.premium = this.quotation.total_premium_due;
            }
          })
          .catch(error => {
              console.log('Error', error);
          }); 
        }else{
          this.showAlert('Incorrect number of travellers!','danger')
        }          
      },
      showAlert(text,variant){
        this.components.bootstrap_alert.dismissCountDown = this.components.bootstrap_alert.dismissSecs;
        this.components.bootstrap_alert.variant = variant;
        this.components.bootstrap_alert.alert_text = text;
      },
      refreshPolicies(){
        const client = {
          id: this.user.data.client_id
        }
        axios
        .get(GET_POLICIES_URL, { params:client })
        .then(response => {
          if (response.status == 200){
            this.policies.oti = response.data.oti;
            this.policies.houseowners = response.data.houseowners;
            this.policies.comprehensive = response.data.comprehensive;
            this.policies.thirdparty = response.data.thirdparty;
            this.policies.muendebwino = response.data.muendebwino;
            ///console.log(this.policies);
          }
        })
        .catch(error => {
          console.log(error);
        }); 
      },
      openBottomSheet(index){
        this.components.bottom_sheet.option_index=index;
        this.components.bottom_sheet.is_open=true;
      },
      callback: function(response) {
        if (response.data.tx.status == "successful" &&  response.data.tx.chargeResponseCode === "00") {
            if (response.data.tx.fraud_status === "ok") {
              this.txref = response.tx.txRef

              var data = null;
            
            // create policy            
              data = {
                "id": this.muendeBwino.quote_id,
                "digital_channel": 2
              }

              axios
              .post(AUTHORIZE_MB_QUOTE_URL, data)
              .then(response => {
                if (response != null){
                  console.log(response);
                  this.muendeBwino.policy_number = response.data;
                  this.closeProduct();

                  this.muendeBwino.national_id='';
                  this.muendeBwino.start_date= '';
                  this.muendeBwino.end_date= '';
                  this.muendeBwino.currency= '';
                  this.muendeBwino.num_of_travellers= '';
                  this.muendeBwino.num_of_months= '';
                  this.muendeBwino.travellers= [];
                  this.muendeBwino.total_value= 0;
                  this.muendeBwino.premium= 0;
                  this.refreshPolicies();
                  this.$router.push('/dashboard')
                }            
              })
              .catch(error => {
                  console.log('Error', error);
              });
            }            
        } else {
            alert("Your payment could not be processed. Please try again later");
        }
      },   
      close: function(){} 
    },
    computed: {
      ...mapGetters({
        user: "user",
        muendeBwino: "muendeBwino",
        components: "components",
        policies: "policies"
      }),
      reference() {
        let text = "";
        let possible =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 10; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
      },
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },
    updated(){
      /*if (this.travelQuote.departure_date.length > 0){
        if (this.travelQuote.duration.length > 0){
          var departureDate = this.$moment(this.travelQuote.departure_date);
          var returnDate = departureDate.add(parseInt(this.travelQuote.duration),'days').format('DD/MM/YYYY');

          this.travelQuote.return_date = returnDate;
        }else{
          this.travelQuote.return_date = '';
        }
      }*/
    },
    created(){
      var options = {
        enableHighAccuracy: false,
        timeout: Infinity, 
        maximumAge: 0 
      }
      this.$getLocation(options)
      .then(coordinates => {
        this.custom.coordinates.latitude = coordinates.lat;
        this.custom.coordinates.longitude = coordinates.lng;
      });
      if (this.user.loggedIn){
        this.custom.phone_number = (this.user.data.phone_number).substr(4,13);
      }
      //console.log(this.muendeBwino);
    }
  }
</script>